import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        alignItems: "center",
        width: "100%",
        height: "100%",
    },
    inputContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        width: "100%",
    },
    label: {
        fontSize: "16px",
        color: "#353535",
    },
    input: {
        borderRadius: "4px",
        backgroundColor: "#FFF",
    },
    buttonSave: {
        color: "#fff",
        minWidth: "100%",
        height: "50px",
        boxShadow:
            "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
        marginTop: "5px",
        marginBottom: "15px",
        textTransform: "none",
        backgroundColor: "#EA3458",

        '&:hover': {
            boxShadow: "none !important",
            backgroundColor: "#EA3458 !important"
        }
    }
}));